import { fromCustomer } from "shared/analytics/useTrackOrder/mappers/analytics-customer.mapper";
import {
  trackCheckoutStarted,
  trackCheckoutStepCompleted,
  trackCheckoutStepViewed,
  trackOrderCompleted,
  trackPaymentInfoEntered,
} from "utils/analytics/analytics.utils";

import { fromOrder } from "./mappers/analytics-order.mapper";
import { useTrackOrderLazyQuery } from "./track-order.query.generated";

type TrackingFunction =
  | typeof trackCheckoutStarted
  | typeof trackCheckoutStepViewed
  | typeof trackCheckoutStepCompleted
  | typeof trackOrderCompleted
  | typeof trackPaymentInfoEntered;

export const useTrackOrder = () => {
  const [order] = useTrackOrderLazyQuery({ fetchPolicy: "network-only" });

  const track =
    (trackingFunction: TrackingFunction) =>
    (orderId: number, extraParams: Record<string, any> = {}) =>
      order({ variables: { orderId } }).then(
        ({ data }) =>
          data?.order &&
          trackingFunction(
            {
              ...fromOrder(data.order),
              ...extraParams,
            },
            fromCustomer(data.customer),
          ),
      );

  return {
    trackCheckoutStarted: track(trackCheckoutStarted),
    trackCheckoutStepViewed: track(trackCheckoutStepViewed),
    trackCheckoutStepCompleted: track(trackCheckoutStepCompleted),
    trackOrderCompleted: track(trackOrderCompleted),
    trackPaymentInfoEntered: track(trackPaymentInfoEntered),
  };
};
